document.addEventListener('DOMContentLoaded', function(){
  const toggle=document.querySelector('[data-menu-toggle]');
  const menu=document.querySelector('[data-navigation]');
  if(toggle&&menu){toggle.addEventListener('click',function(){const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));menu.classList.toggle('is-open',!open);});}
});


/* 3DBazaar v1.8: Add to cart without Shopify's raw quantity-error page.
   Shopify remains the source of truth for B2B quantity rules. */
document.addEventListener('submit', async function(event) {
  const form=event.target;
  if (!(form instanceof HTMLFormElement) ||
      !(form.matches('.dbpc-card__action-form') || form.matches('.dbpd-product-form'))) return;
  event.preventDefault();
  if (form.dataset.submitting==='true') return;

  const quantity=form.querySelector('[name="quantity"]');
  const error=form.querySelector('[data-cart-error]');
  const button=form.querySelector('[type="submit"][data-dbpd-add], .dbpc-card__action[type="submit"]');
  const label=button && button.querySelector('[data-add-label], [data-dbpd-add-label]');
  const originalLabel=label ? label.textContent : '';
  const isCard=form.classList.contains('dbpc-card__action-form');
  function showError(text) {
    if (error) {error.textContent=text;error.hidden=false;}
  }
  if (error) {error.hidden=true;error.textContent='';}

  // Normalize the selected number before submitting.
  if (quantity) {
    const min=Math.max(1,parseInt(quantity.min || form.dataset.quantityMin,10)||1);
    const increment=Math.max(1,parseInt(quantity.step || form.dataset.quantityIncrement,10)||1);
    const max=parseInt(quantity.max || form.dataset.quantityMax,10) || Infinity;
    const entered=parseInt(quantity.value,10)||min;
    const valid=Math.max(min,Math.min(max,min+Math.ceil(Math.max(0,entered-min)/increment)*increment));
    if (valid!==entered) {
      quantity.value=String(valid);
      showError('Minimum order is '+min+' pcs. Quantity adjusted to '+valid+'.');
      return;
    }
  }
  form.dataset.submitting='true';
  if (button) button.disabled=true;
  if (label) label.textContent='Adding…';

  try {
    const action=new URL(form.action,window.location.href);
    const endpoint=action.pathname.replace(/\/$/,'')+'.js';
    const response=await fetch(endpoint,{
      method:'POST',body:new FormData(form),credentials:'same-origin',
      headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}
    });
    const data=await response.json().catch(()=>({}));
    if (!response.ok) {
      let msg=typeof data.description==='string' ? data.description :
        typeof data.message==='string' ? data.message : 'Unable to add this product to cart.';
      const minimum=msg.match(/minimum(?:\s+of)?\s+(\d+)/i);
      if (minimum && quantity) {
        const min=parseInt(minimum[1],10);
        quantity.min=String(min);
        if (isCard) {
          quantity.value=String(min);
          form.dataset.quantityMin=String(min);
          const hint=form.querySelector('[data-quantity-hint]');
          if (hint) {hint.hidden=false;hint.textContent='Minimum order: '+min+' pcs';}
          if (label) label.textContent='Add '+min+' to Cart';
          button && button.setAttribute('aria-label','Add '+min+' to cart');
        } else {
          quantity.value=String(min);
          const hint=form.querySelector('[data-dbpd-quantity-rule]');
          if (hint) {hint.hidden=false;hint.textContent='Minimum order: '+min+' pcs';}
        }
        msg='Minimum order: '+min+' pcs. The quantity has been corrected; please add again.';
      }
      throw new Error(msg);
    }
    // Keep the shopper on the current page. The shared confirmation modal
    // uses the server response and refreshes the cart count from Shopify.
    const root=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root)||'/';
    let cart=null;
    try {
      const cartResponse=await fetch(root+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}});
      if (cartResponse.ok) cart=await cartResponse.json();
    } catch (_) { /* Adding succeeded; the modal can still show the item. */ }
    document.dispatchEvent(new CustomEvent('db:cart-added',{
      detail:{item:data,cart:cart,quantity:parseInt(quantity && quantity.value,10)||parseInt(form.dataset.quantityMin,10)||1}
    }));
  } catch(err) {
    showError(err && err.message || 'Could not add to cart. Please try again.');
  } finally {
    form.dataset.submitting='false';
    if (button) button.disabled=false;
    if (label && (label.textContent==='Adding…')) label.textContent=originalLabel;
  }
});
